export class RailwayCompanyModel {
  constructor(item) {
    const { id, name } = item
    this.id = Number(id) || undefined
    this.name = name || undefined
  }

  static assign(item) {
    return new RailwayCompanyModel(item)
  }
}

export class RailwayLineModel {
  constructor(item) {
    const { id, name, companyId, companyName } = item
    this.id = Number(id) || undefined
    this.name = name || undefined
    this.companyId = Number(companyId) || undefined
    this.companyName = companyName || undefined
  }

  static assign(item) {
    return new RailwayLineModel(item)
  }
}

export class RailwayStationModel {
  constructor(item) {
    const { id, name, companyId, companyName, lineId, lineName } = item
    this.id = Number(id) || undefined
    this.name = name || undefined
    this.companyId = Number(companyId) || undefined
    this.companyName = companyName || undefined
    this.lineId = Number(lineId) || undefined
    this.lineName = lineName || undefined
  }

  static assign(item) {
    return new RailwayStationModel(item)
  }
}

export class RegionModel {
  constructor(item) {
    const { id, code, name, countryId } = item
    this.id = Number(id) || undefined
    this.code = code || undefined
    this.name = name || undefined
    this.countryId = Number(countryId) || undefined
  }

  static assign(item) {
    return new RegionModel(item)
  }
}

export class CityModel {
  constructor(item) {
    const { id, code, name, name_en, region_id } = item
    this.id = Number(id) || undefined
    this.code = code || undefined
    this.name = name || undefined
    this.name_en = name_en || undefined
    this.region_id = Number(region_id) || undefined
  }

  static assign(item) {
    return new CityModel(item)
  }
}

export class LargeClassificationModel {
  constructor(item) {
    const { id, name, sectorCode } = item
    this.id = Number(id) || undefined
    this.name = name || undefined
    this.sectorCode = sectorCode || undefined
  }
  static assign(item) {
    return new LargeClassificationModel(item)
  }
}

export class SmallClassificationModel {
  constructor(item) {
    const { id, name, sectorCode, sectorName } = item
    this.id = Number(id) || undefined
    this.name = name || undefined
    this.sectorCode = sectorCode || undefined
    this.sectorName = sectorName || undefined
  }
  static assign(item) {
    return new SmallClassificationModel(item)
  }
}
